var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "login--page",
      style: { background: "url(" + _vm.backgroundUrl + ");" }
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                {
                  attrs: {
                    xl: "8",
                    "offset-xl": "2",
                    "offset-md": "1",
                    md: "10",
                    sm: "12"
                  }
                },
                [
                  _c("div", { staticClass: "form-container2" }, [
                    _c("div", { staticClass: "form__title2" }, [
                      _c("h3", [
                        _vm._v(_vm._s(_vm.$t("Your account has been created")))
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "In order to continue you have to verify your email account. We send you an email, you just to click on the confirm button, and you are ready to go"
                            )
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form_button" },
                      [
                        _c("kw-button", {
                          attrs: {
                            label: _vm.$t("Back to Homepage"),
                            type: "submit",
                            isPrimary: true
                          },
                          nativeOn: {
                            click: function($event) {
                              return _vm.redirect($event)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "headerAccountCreated" }, [
      _c("div", { staticClass: "header-right" }, [
        _c("a", { attrs: { href: "/" } }, [
          _c("img", {
            staticClass: "imageLogoHeader",
            attrs: { src: require("../../../../assets/logo4login.png") }
          })
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dda17562", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dda17562","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/views/accountCreated/accountCreated.html
// module id = null
// module chunks = 